export class MasterAndSlave {
    masterRecordId: string;
    slavesRecordIds: string[];
    masterEntityId: string;
    slaveEntityId: string;
}